import { useEffect, useRef, useState } from 'react'
import ClickAwayListener from 'react-click-away-listener'
import useMeasure from 'react-use-measure'

// todo move this elsewhere
// open if hovering for 0.8 sec or clicked
export const HoverIcon = (props: any) => {
    const {
        renderIcon,
        children,
        growLeft = false,
        growDown = false,
        offset,
        ignoreClick = false,
    } = props
    // need to track if opened from click or hover
    const [open, setOpen] = useState<boolean | 'hover' | 'click'>(false)
    const openHandleRef = useRef<any>(false)

    const clearOpenTimer = () => {
        // if we have a timer clear it
        if (openHandleRef.current) {
            clearTimeout(openHandleRef.current)
            openHandleRef.current = false
        }
    }
    const onHover = () => {
        // check if there is current open timer and stop if there is one
        if (openHandleRef.current) return
        // don't do anything if already open
        if (open) return
        // start one otherwise
        let handle = setTimeout(() => setOpen('hover'), 500)
        openHandleRef.current = handle
    }
    const onHoverOff = () => {
        // if we have a timer clear it
        clearOpenTimer()
        // close if opened from hover
        if (open === 'hover') setOpen(false)
    }
    const onClick = () => {
        // if we have a timer clear it
        clearOpenTimer()

        setOpen('click')
    }
    const onClickAway = () => {
        clearOpenTimer()
        if (open) {
            setOpen(false)
        }
    }
    const closeBubble = () => {
        setOpen(false)
    }

    const [zIndex, setZIndex] = useState(0)
    useEffect(() => {
        if (open) {
            //@ts-ignore
            window.zIndex = window.zIndex ? window.zIndex + 1 : 1
            //@ts-ignore
            setZIndex(window.zIndex + 1)
        }
    }, [open])

    return (
        <div
            style={{
                display: 'inline-block',
                position: 'relative',
                cursor: ignoreClick ? 'initial' : 'pointer',
                zIndex,
                ...(props.style || {}),
            }}
            onMouseEnter={onHover}
            //if not open yet need to stop the open timer
            onMouseLeave={() => onHoverOff()}
            onClick={ignoreClick ? () => null : onClick}
        >
            {renderIcon()}
            {open && (
                <HoverBubble
                    onClickAway={onClickAway}
                    hoverOff={onHoverOff}
                    growLeft={growLeft}
                    growDown={growDown}
                    offset={offset}
                >
                    {children(closeBubble)}
                </HoverBubble>
            )}
        </div>
    )
}

const HoverBubble = (props: any) => {
    const {
        onClickAway,
        children,
        growLeft = false,
        growDown = false,
        open = true,
        hoverOff,
        offset = 0,
    } = props

    const [ref, bounds] = useMeasure()
    return (
        // 0 on first render
        open && (
            <div
                style={{
                    position: 'absolute',
                    // top: -10,
                    // left: 0,
                    top: growDown ? 'auto' : -10,
                    bottom: growDown ? -10 : 'auto',
                    left: growLeft ? -10 : 0,

                    width: '100%',
                    height: '100%',
                }}
                onMouseLeave={(e) => {
                    hoverOff()
                    e.stopPropagation()
                }}
            >
                <ClickAwayListener onClickAway={onClickAway}>
                    <div
                        onMouseOver={(e) => {
                            e.stopPropagation()
                        }}
                        style={{
                            position: 'absolute',
                            top: growDown ? 'auto' : 10 - bounds.height,
                            bottom: growDown ? 15 - bounds.height : 'auto',
                            left: growLeft ? 'auto' : -offset,
                            right: growLeft ? -offset : 'auto',
                            // first render isn't going to be in right spot so hide it
                            visibility: !!bounds.height ? 'visible' : 'hidden',
                        }}
                    >
                        <div ref={ref}>{children}</div>
                    </div>
                </ClickAwayListener>
            </div>
        )
    )
}
